import _ from 'lodash';

export function lastProcess(processes: any, goodsId: string): string {
  let lastProcess: string = '';
  _.each(processes, (currentProcess: any) => {
    _.each(currentProcess.outputs, (currentOutput: any) => {
      if(currentOutput._id === goodsId) {
        lastProcess = currentProcess.type;
      }
    })
  })
  return lastProcess;
}